export const HUB_SERVICE_AREA_STRINGS = [
  "Columbus IN",
  "Indianapolis IN",
  "Carmel IN",
  "Fishers IN",
  "Greenwood IN",
  "Avon IN",
  "Plainfield IN",
  "Zionsville IN",
  "Franklin IN",
  "Bloomington IN",
  "Seymour IN",
  "Shelbyville IN",
  "Greensburg IN",
  "North Vernon IN",
  "Sellersburg IN",
  "Nashville IN",
  "Danville IN",
  "Martinsville IN",
  "Ellettsville IN",
  "Whiteland IN",
  "Bargersville IN",
  "Edinburgh IN",
  "Fairland IN",
  "Saint Paul IN",
  "Hope IN",
  "Taylorsville IN",
  "Elizabethtown IN",
  "Madison IN",
  "Bedford IN",
  "Scottsburg IN",
  "New Albany IN",
  "Jeffersonville IN",
  "Clarksville IN",
  "Richmond IN",
  "Batesville IN",
  "Versailles IN",
  "Rushville IN",
  "Salem IN",
  "Lawrenceburg IN",
];

export const FEATURED_SERVICE_AREA_SLUGS = [
  "columbus",
  "bloomington",
  "indianapolis",
  "carmel",
  "fishers",
  "greenwood",
];

export const LOCATION_SEO_DATA = {
  "columbus": {
    path: "/columbus-movers",
    title: "Movers and Cleaners in Columbus IN | Local, Licensed & Insured | Swift Move and Clean",
    description: "Swift Move and Clean offers professional moving and house cleaning in Columbus, IN. Serving 47201, 47202, 47203. Zero travel fees in Bartholomew County. Free quote!",
    nearbySlugs: ["edinburgh", "hope", "taylorsville"],
  },
  "indianapolis": {
    path: "/indianapolis-movers",
    title: "Movers & Cleaners in Indianapolis IN | Licensed & Insured | Swift Move and Clean",
    description: "Need reliable movers or cleaners in Indianapolis? Swift Move and Clean serves 46201 and all 46xxx zip codes. Free estimates. Call today!",
    nearbySlugs: ["greenwood", "carmel", "fishers"],
  },
  "carmel": {
    path: "/carmel-movers",
    title: "Carmel Movers & Cleaners | High-Value Relocation Specialists | Swift Move and Clean",
    description: "Specializing in high-value moves in Carmel, IN. We handle Pelotons, wall mirrors, and hardwood floors with care. Serving 46032. Free quote!",
    nearbySlugs: ["indianapolis", "fishers", "zionsville"],
  },
  "fishers": {
    path: "/fishers-movers",
    title: "Fishers Movers & Cleaners | New Construction & Family Relocation | Swift Move and Clean",
    description: "Moving in Fishers? We serve 46037, Saxony, Brooks Chase, and Geist communities. Family-friendly moving and cleaning. Free estimate!",
    nearbySlugs: ["carmel", "indianapolis", "greenwood"],
  },
  "greenwood": {
    path: "/greenwood-movers",
    title: "Greenwood IN Movers & Cleaners | Local & Affordable | Swift Move and Clean",
    description: "Swift Move and Clean provides reliable moving and cleaning in Greenwood, IN. Serving 46142 near Stones Crossing and Main Street. Free quote!",
    nearbySlugs: ["indianapolis", "franklin", "whiteland"],
  },
  "avon": {
    path: "/avon-movers",
    title: "Avon Movers & Cleaners | Family Moving Specialists | Swift Move and Clean",
    description: "Moving in Avon, IN? We help families upgrade to larger homes. Serving 46123 near Prestwick and Hendricks Regional. Free estimate!",
    nearbySlugs: ["plainfield", "danville", "indianapolis"],
  },
  "plainfield": {
    path: "/plainfield-movers",
    title: "Plainfield Movers & Cleaners | Residential & Commercial | Swift Move and Clean",
    description: "Plainfield moves made easy. We serve 46168 for both residential family moves and office relocations. Licensed and insured. Free quote!",
    nearbySlugs: ["avon", "danville", "indianapolis"],
  },
  "zionsville": {
    path: "/zionsville-movers",
    title: "Zionsville Movers & Cleaners | Historic & Large Home Specialists | Swift Move and Clean",
    description: "Expert moving and cleaning in Zionsville, IN. We handle 4-5 bedroom homes and historic Brick Street properties. Serving 46077. Free quote!",
    nearbySlugs: ["carmel", "indianapolis", "plainfield"],
  },
  "franklin": {
    path: "/franklin-movers",
    title: "Franklin IN Movers & Cleaners | Historic & New Home Moves | Swift Move and Clean",
    description: "Moving in Franklin? We handle historic downtown homes and new subdivisions. Serving 46131. Licensed and insured. Free estimate!",
    nearbySlugs: ["greenwood", "whiteland", "bargersville"],
  },
  "bloomington": {
    path: "/bloomington-cleaning",
    title: "Bloomington Movers & Cleaners | IU Student Move Specialists | Swift Move and Clean",
    description: "IU student moving and house cleaning in Bloomington, IN. We run dedicated crews for May and August move waves. Serving 47401-47408. Free quote!",
    nearbySlugs: ["ellettsville", "martinsville", "bedford"],
  },
  "seymour": {
    path: "/seymour-movers",
    title: "Seymour Movers & Cleaners | Residential & Estate Moves | Swift Move and Clean",
    description: "Fast dispatch to Seymour, IN — crews on site in about 30 minutes. We handle residential, farm estate, and commercial moves. Serving 47274. Free quote!",
    nearbySlugs: ["columbus", "north-vernon", "scottsburg"],
  },
  "shelbyville": {
    path: "/shelbyville-movers",
    title: "Shelbyville Movers & Cleaners | Family Relocation | Swift Move and Clean",
    description: "Moving in Shelbyville? We help families who commute to Indy. Serving 46176. Back-road shortcuts save you money. Free estimate!",
    nearbySlugs: ["fairland", "saint-paul", "greensburg"],
  },
  "greensburg": {
    path: "/greensburg-movers",
    title: "Greensburg Movers & Cleaners | Honda Relocation Specialists | Swift Move and Clean",
    description: "Greensburg moves — including Honda employee relocations. We serve 47240 with weekly routes. Less than a week's notice often available. Free quote!",
    nearbySlugs: ["shelbyville", "saint-paul", "rushville"],
  },
  "north-vernon": {
    path: "/north-vernon-movers",
    title: "North Vernon Movers & Cleaners | Family & Cross-County Moves | Swift Move and Clean",
    description: "Moving in or out of North Vernon? We handle family transitions and cross-county relocations. Serving 47265. Free estimate!",
    nearbySlugs: ["seymour", "madison", "columbus"],
  },
  "sellersburg": {
    path: "/sellersburg-movers",
    title: "Sellersburg Movers & Cleaners | Louisville Metro & Cross-State Moves | Swift Move and Clean",
    description: "Serving Sellersburg, IN and the Louisville metro. We handle cross-state moves between Indiana and Kentucky with zero paperwork hassle. Free quote!",
    nearbySlugs: ["jeffersonville", "clarksville", "new-albany"],
  },
  "nashville": {
    path: "/nashville-movers",
    title: "Nashville IN Movers & Cleaners | Art & Antique Moving Specialists | Swift Move and Clean",
    description: "Moving art, antiques, or cabins in Nashville, IN? We provide extra care for valuable collections. Serving 47448. Free estimate!",
    nearbySlugs: ["columbus", "bloomington", "martinsville"],
  },
  "danville": {
    path: "/danville-movers",
    title: "Danville Movers & Cleaners | Family & In-Town Relocation | Swift Move and Clean",
    description: "Quiet, respectful moving and cleaning in Danville, IN. We handle in-town family moves near the courthouse square. Serving 46122. Free quote!",
    nearbySlugs: ["plainfield", "avon", "indianapolis"],
  },
  "martinsville": {
    path: "/martinsville-movers",
    title: "Martinsville Movers & Cleaners | Rural & Commuter Moves | Swift Move and Clean",
    description: "Serving Martinsville, IN on I-69 corridor. We handle rural family moves, retiree downsizes, and Foxcliff Estates relocations. Free estimate!",
    nearbySlugs: ["bloomington", "ellettsville", "nashville"],
  },
  "ellettsville": {
    path: "/ellettsville-movers",
    title: "Ellettsville Movers & Cleaners | Edgewood School District | Swift Move and Clean",
    description: "Family moves in Ellettsville, IN — especially near Edgewood schools. Our Bloomington crews dispatch same day. Serving 47429. Free quote!",
    nearbySlugs: ["bloomington", "martinsville", "bedford"],
  },
  "whiteland": {
    path: "/whiteland-movers",
    title: "Whiteland Movers & Cleaners | First-Time Homebuyer Moves | Swift Move and Clean",
    description: "First-time homebuyer moves in Whiteland, IN? We serve 46184 near Tracy Road and Clark-Pleasant schools. Quick dispatch from Columbus. Free quote!",
    nearbySlugs: ["franklin", "greenwood", "bargersville"],
  },
  "bargersville": {
    path: "/bargersville-movers",
    title: "Bargersville Movers & Cleaners | Center Grove School District | Swift Move and Clean",
    description: "Large family moves in Bargersville, IN. We know the subdivisions and historic streets near Center Grove schools. Serving 46106. Free estimate!",
    nearbySlugs: ["whiteland", "franklin", "greenwood"],
  },
  "edinburgh": {
    path: "/edinburgh-movers",
    title: "Edinburgh Movers & Cleaners | Camp Atterbury Relocation Specialists | Swift Move and Clean",
    description: "Military and civilian relocations to/from Camp Atterbury. We know the paperwork. Serving 46124. Quick dispatch — under 20 minutes from Columbus. Free quote!",
    nearbySlugs: ["columbus", "hope", "taylorsville"],
  },
  "fairland": {
    path: "/fairland-movers",
    title: "Fairland IN Movers & Cleaners | Rural & Acreage Moves | Swift Move and Clean",
    description: "Rural family moves and estate relocations in Fairland, IN. Trucks and crews comfortable with rural roads. Serving 46126. Free estimate!",
    nearbySlugs: ["shelbyville", "greenwood", "whiteland"],
  },
  "saint-paul": {
    path: "/saint-paul-movers",
    title: "Saint Paul IN Movers & Cleaners | Estate & Transition Specialists | Swift Move and Clean",
    description: "Estate transitions, retiree downsizes, and rural family moves in Saint Paul, IN. Serving 47272. Fair, honest pricing. Free quote!",
    nearbySlugs: ["greensburg", "shelbyville", "rushville"],
  },
  "hope": {
    path: "/hope-movers",
    title: "Hope IN Movers & Cleaners | Historic Square & In-Town Moves | Swift Move and Clean",
    description: "First-home moves and in-town cleanings in Hope, IN. Zero travel fee — inside our 30-minute zone. Serving 47246. Free estimate!",
    nearbySlugs: ["columbus", "edinburgh", "taylorsville"],
  },
  "taylorsville": {
    path: "/taylorsville-movers",
    title: "Taylorsville IN Movers & Cleaners | Commuter Relocation | Swift Move and Clean",
    description: "Full moving and cleaning services in Taylorsville, IN at standard Columbus pricing. No travel fee. Serving 47280. Free quote!",
    nearbySlugs: ["columbus", "hope", "edinburgh"],
  },
  "elizabethtown": {
    path: "/elizabethtown-movers",
    title: "Elizabethtown IN Movers & Cleaners | Rural & Farmhouse Relocation | Swift Move and Clean",
    description: "Rural family moves, estate cleanouts, and farmhouse cleanings in Elizabethtown, IN. Standard Columbus rates. Serving 47232. Free estimate!",
    nearbySlugs: ["columbus", "taylorsville", "hope"],
  },
  "madison": {
    path: "/madison-movers",
    title: "Madison IN Movers & Cleaners | Historic District & River Town Specialists | Swift Move and Clean",
    description: "Historic home moves in Madison, IN — including National Landmark District and Hanover College. Extra care for original floors and narrow stairs. Free quote!",
    nearbySlugs: ["north-vernon", "salem", "scottsburg"],
  },
  "bedford": {
    path: "/bedford-movers",
    title: "Bedford IN Movers & Cleaners | Limestone Capital Moves | Swift Move and Clean",
    description: "Residential relocations and estate moves in Bedford, IN. We serve commuters heading to Bloomington or Columbus. Serving 47421. Free estimate!",
    nearbySlugs: ["bloomington", "ellettsville", "martinsville"],
  },
  "scottsburg": {
    path: "/scottsburg-movers",
    title: "Scottsburg IN Movers & Cleaners | I-65 Corridor Specialists | Swift Move and Clean",
    description: "Commuter family moves and retiree relocations in Scottsburg, IN. We run the I-65 corridor weekly. Serving 47170. Free quote!",
    nearbySlugs: ["new-albany", "jeffersonville", "sellersburg"],
  },
  "new-albany": {
    path: "/new-albany-movers",
    title: "New Albany Movers & Cleaners | Louisville Metro & Cross-River Moves | Swift Move and Clean",
    description: "Historic Mansion Row moves, IU Southeast faculty relocations, and cross-river IN-KY moves. Serving 47150. Free estimate!",
    nearbySlugs: ["jeffersonville", "clarksville", "sellersburg"],
  },
  "jeffersonville": {
    path: "/jeffersonville-movers",
    title: "Jeffersonville Movers & Cleaners | Louisville Metro & Waterfront Moves | Swift Move and Clean",
    description: "Ohio River waterfront moves and cross-state IN-KY relocations. We handle every paperwork detail. Serving 47129. Free quote!",
    nearbySlugs: ["clarksville", "new-albany", "sellersburg"],
  },
  "clarksville": {
    path: "/clarksville-movers",
    title: "Clarksville IN Movers & Cleaners | Louisville Metro Commercial & Residential | Swift Move and Clean",
    description: "Family and commercial moves in Clarksville, IN along Veterans Parkway. Cross-state moves to Kentucky are our specialty. Serving 47129. Free estimate!",
    nearbySlugs: ["jeffersonville", "new-albany", "sellersburg"],
  },
  "richmond": {
    path: "/richmond-movers",
    title: "Richmond IN Movers & Cleaners | Earlham & IU East Faculty Moves | Swift Move and Clean",
    description: "Academic relocations for Earlham College and IU East. Serving 47374. Cross-state moves to Ohio available. Free quote!",
    nearbySlugs: ["batesville", "lawrenceburg", "rushville"],
  },
  "batesville": {
    path: "/batesville-movers",
    title: "Batesville IN Movers & Cleaners | Hillenbrand & Medical Staff Relocation | Swift Move and Clean",
    description: "Executive and medical staff relocations in Batesville, IN. We serve I-74 corridor. Serving 47006. Free estimate!",
    nearbySlugs: ["greensburg", "versailles", "lawrenceburg"],
  },
  "versailles": {
    path: "/versailles-movers",
    title: "Versailles IN Movers & Cleaners | Lake & Rural Relocation Specialists | Swift Move and Clean",
    description: "Lake-cabin transitions, estate moves, and rural family relocations in Versailles, IN. Serving 47042. Free quote!",
    nearbySlugs: ["batesville", "lawrenceburg", "madison"],
  },
  "rushville": {
    path: "/rushville-movers",
    title: "Rushville IN Movers & Cleaners | Farm Estate & In-Town Moves | Swift Move and Clean",
    description: "Farm-estate transitions and family moves in Rushville, IN. We run SR-3 / US-52 corridor. Serving 46173. Free estimate!",
    nearbySlugs: ["greensburg", "saint-paul", "shelbyville"],
  },
  "salem": {
    path: "/salem-movers",
    title: "Salem IN Movers & Cleaners | Washington County Courthouse Square | Swift Move and Clean",
    description: "Commuter relocations and retiree downsizes in Salem, IN. We run SR-135 / SR-56 weekly. Serving 47167. Free quote!",
    nearbySlugs: ["scottsburg", "madison", "new-albany"],
  },
  "lawrenceburg": {
    path: "/lawrenceburg-movers",
    title: "Lawrenceburg IN Movers & Cleaners | Ohio River & Cross-State Moves | Swift Move and Clean",
    description: "Hollywood Casino staff moves and cross-state IN-to-OH relocations. Serving 47025. Free estimate!",
    nearbySlugs: ["versailles", "batesville", "richmond"],
  },
};

export const getLocationSeoData = (slug) => LOCATION_SEO_DATA[slug] || null;

export const getLocationLandingPath = (slug) =>
  LOCATION_SEO_DATA[slug]?.path || `/locations/${slug}`;

export const resolveLocationSlug = (value) => {
  if (!value) return null;

  const directMatch = Object.keys(LOCATION_SEO_DATA).find(
    (slug) => slug === value
  );
  if (directMatch) return directMatch;

  const aliasMatch = Object.entries(LOCATION_SEO_DATA).find(
    ([, data]) => data.path.slice(1) === value
  );
  return aliasMatch ? aliasMatch[0] : value;
};

export const getNearbyLocationSlugs = (slug) =>
  LOCATION_SEO_DATA[slug]?.nearbySlugs || [];
